import ofertaEmprendedores from "@/config/constants/ofertaCGU";

let infoCA = {
  oferta: [
    {
      label: "Cuenta Gratuita Universal",
      description: ""
    },
    {
      label: "Tarjeta <strong>Visa Débito</strong>",
      description: ""
    }
  ]
};
describe("OfertaEmprendedores config", () => {
  it("configuracion exportada por defecto", () => {
    const result = ofertaEmprendedores();

    expect(result).toBeDefined();
    expect(result).not.toBeNull();

    expect(result).toEqual(infoCA);

    expect(result).toHaveProperty("oferta");

    expect(result.oferta[0].label).toStrictEqual(infoCA.oferta[0].label);
  });
});
